import {useState} from 'react'
import {Modal} from '@freckle/educator-materials/ts/components/support-button/admin/modal'
import {TriggerButton} from '@freckle/educator-materials/ts/components/support-button/admin/trigger-button'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'

type Props = {
  countryCode: string | null
}

export function AdminSupportButton({countryCode}: Props) {
  const {t} = useSafeTranslation()
  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  return (
    <>
      <Modal showModal={showModal} onCloseModal={toggleModal} countryCode={countryCode} />
      <TriggerButton onClick={toggleModal} text={t('SUPPORT_BUTTON_HELP')} invertColors />
    </>
  )
}
